import { render, staticRenderFns } from "./TabCmp.vue?vue&type=template&id=95a7e786&"
import script from "./TabCmp.vue?vue&type=script&lang=js&"
export * from "./TabCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports